import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveyContentContainer from '../components/SurveyContentContainer';
import GenericSubmitPage from "../components/GenericSubmitPage";

export const PabsUkSubmitTab = () => {
  return (
    <SurveyPage>
      <SurveyTitleArea />
      <SurveyContentContainer>
        <GenericSubmitPage />
      </SurveyContentContainer>
    </SurveyPage>
  )
}